import { render, staticRenderFns } from "./menuApp.vue?vue&type=template&id=2c66e80a&"
import script from "./menuApp.vue?vue&type=script&lang=js&"
export * from "./menuApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports